import { useContext } from "react";
import { AuthContext } from "../context/AuthContextProvider";
import { AudioVideoContext } from "../context/AudioVideoContextProvider";
import { GeneralContext } from "../context/GeneralContextProvider";

const useAuthContext = () => useContext(AuthContext);
export const useAudioVideoContext = () => useContext(AudioVideoContext);
export const useGeneralContext = () => useContext(GeneralContext);
export default useAuthContext;
